import { createFileRoute } from "@tanstack/react-router";
import { CommandHistoryPage } from "../../../components/system/CommandHistoryPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/command-history/")({
  beforeLoad: requireSuperAdmin(),
  component: CommandHistoryPage,
});
